const KEY = "pdm_referral";

export const getReferral = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

export const saveReferral = (data) => localStorage.setItem(KEY, JSON.stringify({ ...getReferral(), ...data }));

export const markWelcomeUsed = () => {
  const r = getReferral();
  if (r) saveReferral({ welcome_used: true });
};
